import type { FieldDictionaryV1 } from './fieldDictionary'
import type { SelectedFieldsV1 } from './selectedFields'

export type AnalysisSessionSourceV1 =
  | { kind: 'worksheet_sql'; sql: string }
  | { kind: 'parquet_uri'; parquet_uri: string; sql?: string | null }
  | { kind: 'oracle_rows'; columns: string[]; rows: unknown[][] }

export type AnalysisSessionV1 = {
  version: 1
  session_key: string
  entity_key: string
  source: AnalysisSessionSourceV1
  base_table: string
  tidy_table: string
  selected_fields?: SelectedFieldsV1 | null
  field_dictionary?: FieldDictionaryV1 | null
  created_at_ms: number
}

export const makeAnalysisSessionKeyV1 = (): string => {
  // Keep table-name safe: fg_* tables are restricted to [a-z0-9_].
  const raw = (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function')
    ? crypto.randomUUID()
    : `${Date.now()}_${Math.random().toString(36).slice(2)}`
  return raw.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '').slice(0, 48) || `${Date.now()}`
}

